<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      版权所有  © {{ new Date().getFullYear() }}
      <span class="d-none d-sm-inline-block">, {{ $store.state.systeminfo.systeminfo.copyright }}</span>
    </span>

    <span class="float-md-right d-none d-md-block">版本 &amp; {{ $store.state.systeminfo.systeminfo.version }}
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
